// src/packages/msig/pa/msig_pa_triple_care_2025/index.js
import MSIGTripleCareCard from "./MSIGTripleCareCard";
import MSIGTripleCareDetails from "./MSIGTripleCareDetails";
import "./msig_triple_care.css";

/** MSIG — E-PA Triple Care (Plans 1–9), Effective 2025 */
export default {
  id: "msig_pa_triple_care_2025",
  company: "MSIG ประกันภัย",            // ต้องตรงกับ COMPANY_INFO
  productLine: "non-motor",              // หรือ "pa" ถ้ามีหมวดเฉพาะ
  categories: ["personal accident", "health", "PA"],
  nameTH: "MSIG PA Triple Care — แผน 1–9",
  description: "ประกันอุบัติเหตุส่วนบุคคล ครอบคลุมชีวิต/ทุพพลภาพ/ค่ารักษา ฯลฯ",
  accent: "#e11d48",                     // โทน MSIG
  expiresAt: "9999-12-31",
  card: MSIGTripleCareCard,
  detail: MSIGTripleCareDetails,
  active: true
};
